import * as i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { default as HttpBackend } from "i18next-http-backend";
import { default as LanguageDetector } from "i18next-browser-languagedetector";

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en"],
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
  })
  .catch((e) => console.error(e));
